module.exports = __webpack_public_path__ + "img/jituanyou.3b19ac2c.png";